import {
  either, isEmpty, isNil, merge,
} from 'ramda';
import KeyState from './KeyState';

const isNilOrEmpty = either(isNil, isEmpty);

export default class Key {
  path = [];

  data = {};

  readers = [];

  writers = [];

  state = KeyState.EMPTY;

  isSelected = false;

  error = null;

  basicAuth = false;

  constructor({
    path = [],
    data = {},
    readers = [],
    writers = [],
    state = KeyState.EMPTY,
    isSelected = false,
    error = null,
    basicAuth = false,
  } = {}) {
    this.path = path;
    this.data = data;
    this.readers = readers;
    this.writers = writers;
    this.state = state;
    this.isSelected = isSelected;
    this.error = error;
    this.basicAuth = basicAuth;

    Object.freeze(this);
  }

  static empty() {
    return Key.from({});
  }

  static from(obj) {
    return new Key(obj);
  }

  set(obj) {
    return new Key(merge(this, obj));
  }

  clear() {
    return new Key({ path: this.path });
  }

  validate() {
    if (isNilOrEmpty(this.path)) throw new Error('Key must not have an empty path');
    if (isNilOrEmpty(this.data)) throw new Error('Key must contain some JSON data');
  }
}
